import React from "react";

const D =
  "M6 1.125C5.03582 1.125 4.09329 1.41091 3.2916 1.94659C2.48991 2.48226 1.86507 3.24363 1.49609 4.13442C1.12711 5.02521 1.03057 6.00541 1.21867 6.95107C1.40678 7.89672 1.87108 8.76536 2.55286 9.44715C3.23464 10.1289 4.10328 10.5932 5.04894 10.7813C5.99459 10.9694 6.97479 10.8729 7.86558 10.5039C8.75637 10.1349 9.51775 9.51009 10.0534 8.7084C10.5891 7.90671 10.875 6.96418 10.875 6C10.8736 4.70749 10.3596 3.46831 9.44564 2.55436C8.5317 1.64042 7.29251 1.12636 6 1.125ZM7.39032 6.26531L5.51532 8.14031C5.48047 8.17515 5.43911 8.20279 5.39359 8.22165C5.34807 8.2405 5.29928 8.25021 5.25 8.25021C5.20073 8.25021 5.15194 8.2405 5.10642 8.22165C5.06089 8.20279 5.01953 8.17515 4.98469 8.14031C4.94985 8.10547 4.92221 8.06411 4.90335 8.01859C4.8845 7.97306 4.87479 7.92427 4.87479 7.875C4.87479 7.82573 4.8845 7.77694 4.90335 7.73141C4.92221 7.68589 4.94985 7.64453 4.98469 7.60969L6.59485 6L4.98469 4.39031C4.91432 4.31995 4.87479 4.22451 4.87479 4.125C4.87479 4.02549 4.91432 3.93005 4.98469 3.85969C5.05505 3.78932 5.15049 3.74979 5.25 3.74979C5.34951 3.74979 5.44495 3.78932 5.51532 3.85969L7.39032 5.73469C7.42518 5.76951 7.45284 5.81087 7.47171 5.8564C7.49058 5.90192 7.5003 5.95072 7.5003 6C7.5003 6.04928 7.49058 6.09808 7.47171 6.1436C7.45284 6.18913 7.42518 6.23049 7.39032 6.26531Z";

export default function TicketStatusChevronCircle12({ className }) {
  return (
    <svg
      className={className}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      focusable="false"
    >
      <path d={D} fill="currentColor" />
    </svg>
  );
}
